import { Component, Input, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { OptionsList } from "@app/definitions/opts"
import { Modalable } from "@app/Modalable"
import { DateFormatPipe } from "@app/utils/date-format.pipe"
import { TimeFormatPipe } from "@app/utils/time-format.pipe"
import { SpinOrContent, TableWrapComponent } from "@app/utils/utils.component"
import * as moment from "moment"

@Component({
	selector: "app-patient-fuses",
	imports: [
		COMMON_IMPORTS,
		SpinOrContent,
		TableWrapComponent,
		TimeFormatPipe,
		DateFormatPipe,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<app-spin-or-content [isSpin]="isLoading">
			<app-table-wrap fieldsStr="date,day,time">
				@for (row of rows; track row) {
					<tr>
						<td>
							{{
								row.series_repeat == "one_time"
									? (row.date | dateFormat)
									: row.repeatName
							}}
						</td>
						<td>{{ row.dayName }}</td>
						<td>{{ row.time | timeFormat }}</td>
					</tr>
				}
			</app-table-wrap>
		</app-spin-or-content>
	`,
})
export class PatientFusesComponent extends Modalable {
	OptionsList = OptionsList
	@Input() patient_id: any = null
	rows: any[] = []
	isLoading: boolean = false

	async ngOnInit() {
		this.isLoading = true
		this.rows = await this.store.getFutureFuses(this.patient_id)
		this.isLoading = false
	}
}
